import Moment from 'moment';
import React from 'react';
import php from 'phpjs';

export default {

	Date: function(value) {
		if (value) {
			return new Moment(value).format('D.M.YYYY');
		}
	},

	DateTime: function(value) {
		if (value) {
			return new Moment(value).format('D.M.YYYY H:mm');
		}
	},

	Time: function(value) {
		if (value) {
			return Math.floor(value / 60) + ':' + (value % 60 < 10 ? 0 : '') + value % 60;
		}
	},

	Number: function(value) {
		if (value !== null) {
			var match = (''+value).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
			if (!match) { return php.number_format(value, 0, ',', ' '); }
			let places = Math.max(
				0, (match[1] ? match[1].length : 0)
				- (match[2] ? +match[2] : 0));
			return php.number_format(value, places, ',', ' ');
		}
	},

	Check: function(val) {
		const cn = val ? 'icon-checkmark3' : ' icon-cross2';
		return <div style={{textAlign:'center'}}><span style={{color:'#444', fontSize: 13}} className={cn}></span></div>;
	},

	coloredCheck: function(val) {
		const cn = val ? 'icon-checkmark3' : ' icon-cross2';
		return <div style={{textAlign:'center'}}><span style={{color: (val ? '#484' : '#800'), fontSize: 13}} className={cn}></span></div>;
	},

	CheckThin: function(val, center = true) {
		const cn = val ? 'icon-checkmark2' : ' icon-cross3';
		return <span style={{textAlign: center ? 'center' : null}}><span style={{color:'#444', fontSize: 15}} className={cn}></span></span>;
	},

	DbInfo: function(value) {
		if (typeof value !== 'undefined' || value !== null) {
			var v;
			Object.keys(this).forEach(key => {
				if (this[key].id == value) {
					v = this[key].title;
				}
			});
			return v;
		}
	}
};



// WEBPACK FOOTER //
// ./src/helpers/Renderers.js